import { relations } from 'drizzle-orm'
import { index, pgTable, text, unique } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getId,
  getIdReference,
} from '../common/utils'
import { customers } from './customer'
import { opportunities } from './opportunity'

export const tags = pgTable(
  'tags',
  {
    ...getBaseFields(),
    name: text().notNull(),
    color: text().notNull().default('gray'),
    description: text(),
  },
  (table) => [
    ...getBaseIndexes('tags', table),
    unique('tags_name_unique').on(table.name),
  ],
)

export const opportunityTags = pgTable(
  'opportunity_tags',
  {
    id: getId(),
    opportunityId: getIdReference(() => opportunities.id),
    tagId: getIdReference(() => tags.id),
  },
  (table) => [
    index('opportunity_tags_opportunity_id_idx').on(table.opportunityId),
    index('opportunity_tags_tag_id_idx').on(table.tagId),
    unique('opportunity_tags_unique').on(table.opportunityId, table.tagId),
  ],
)

// Sales-owned labels on a customer, sharing the `tags` vocabulary with
// opportunities. Carries no timestamps or author — a tag is a boolean, which is
// why structural facts ("ei tulisijoja") will eventually move to a typed
// per-service qualification record instead of living here forever.
export const customerTags = pgTable(
  'customer_tags',
  {
    id: getId(),
    customerId: getIdReference(() => customers.id),
    tagId: getIdReference(() => tags.id),
  },
  (table) => [
    index('customer_tags_customer_id_idx').on(table.customerId),
    index('customer_tags_tag_id_idx').on(table.tagId),
    unique('customer_tags_unique').on(table.customerId, table.tagId),
  ],
)

export const tagsRelations = relations(tags, ({ many }) => ({
  opportunityTags: many(opportunityTags),
  customerTags: many(customerTags),
}))

export const customerTagsRelations = relations(customerTags, ({ one }) => ({
  customer: one(customers, {
    fields: [customerTags.customerId],
    references: [customers.id],
  }),
  tag: one(tags, {
    fields: [customerTags.tagId],
    references: [tags.id],
  }),
}))

export const opportunityTagsRelations = relations(
  opportunityTags,
  ({ one }) => ({
    opportunity: one(opportunities, {
      fields: [opportunityTags.opportunityId],
      references: [opportunities.id],
    }),
    tag: one(tags, {
      fields: [opportunityTags.tagId],
      references: [tags.id],
    }),
  }),
)
